import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Programs from './components/Programs';
import Showcase from './components/Showcase';
import Schedule from './components/Schedule';
import Story from './components/Story';
import Coaches from './components/Coaches';
import Testimonials from './components/Testimonials';
import Membership from './components/Membership';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import './App.css';

function App() {
  const [activeDay, setActiveDay] = useState('MON');
  return (
    <div className="site-shell" id="top">
      <Header />
      <main>
        <Hero />
        <Stats />
        <Programs />
        <Showcase />
        <Schedule activeDay={activeDay} onDayChange={setActiveDay} />
        <Story />
        <Coaches />
        <Testimonials />
        <Membership />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
export default App;
